/**
 * Fabric.js v7 patch: fast grapheme split for plain text.
 *
 * Fabric splits every word into graphemes with `Intl.Segmenter` each time a
 * text is laid out, and that split is the largest single cost of laying out
 * the texts when an ad set opens. In printable ASCII and Latin-1 every
 * character is a grapheme on its own, so such strings are split by character;
 * anything else (emoji, combining marks, other scripts) still goes through
 * Fabric's own split. `graphemeSplit` is the hook Fabric provides for this.
 */
import { FabricText } from 'fabric';

const SINGLE_CHAR_GRAPHEMES = /^[\u0020-\u007E\u00A0-\u00FF]*$/;

const graphemeSplit = FabricText.prototype.graphemeSplit;

FabricText.prototype.graphemeSplit = function (
  this: FabricText,
  value: string
): string[] {
  return SINGLE_CHAR_GRAPHEMES.test(value)
    ? value.split('')
    : graphemeSplit.call(this, value);
};
